/**
 * 权限定义
 */
const ACCESS_ENUM = {
  NOT_LOGIN: "notLogin", // 不需要登录
  USER: "user", // 需要登录（用户）
  ADMIN: "admin", // 需要管理员
};

export default ACCESS_ENUM;
